const setDirectoryProfiles = (state, payload) => {
  state.directoryProfiles = payload;
};

export default {
  setDirectoryProfiles,
};
